import React from 'react';
import axios from '../helpers/axiosConfig';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function User() {
  const [listUser, setListUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get('/auth');
      setListUsers(response.data);
    } catch (error) {
      console.error("Erreur lors du chargement des utilisateurs", error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Voulez-vous vraiment supprimer cet utilisateur ?")) return;

    try {
      await axios.delete(`/auth/${id}`);
      setListUsers(listUser.filter((user) => user.id !== id));
      alert("Utilisateur supprimé avec succès !");
    } catch (error) {
      console.error("Erreur lors de la suppression", error);
      alert("Une erreur est survenue lors de la suppression de l'utilisateur.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 px-4 py-10">
      <div className="max-w-4xl mx-auto">

        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-semibold text-white flex items-center gap-2">
            <i className="fa fa-users text-cyan-400"></i>
            Liste des utilisateurs
          </h2>
          <a
            href="/createdusers"
            className="flex items-center gap-2 px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white text-sm font-medium rounded-xl transition-colors duration-200"
          >
            <i className="fa fa-plus text-xs"></i>
            Créer un utilisateur
          </a>
        </div>

        <div className="bg-gray-900 border border-gray-700 rounded-2xl overflow-hidden">
          <table className="w-full text-sm text-left">
            <thead className="bg-gray-800 text-cyan-400 text-xs uppercase">
              <tr>
                <th className="px-4 py-3 font-medium">#</th>
                <th className="px-4 py-3 font-medium">Login</th>
                <th className="px-4 py-3 font-medium">Rôle</th>
                <th className="px-4 py-3 font-medium">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-800">
              {listUser.map((element, k) => (
                <tr key={k} className="text-gray-300 hover:bg-gray-800/50 transition-colors">
                  <td className="px-4 py-3">{element.id}</td>
                  <td className="px-4 py-3">{element.username}</td>
                  <td className="px-4 py-3">{element.roles}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <Link className="text-cyan-400 hover:text-cyan-300" to={`/auth/edit/${element.id}`}>
                        <i className="fa fa-edit"></i>
                      </Link>
                      <button
                        className="text-red-500 hover:text-red-400"
                        onClick={() => handleDelete(element.id)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}

              {listUser.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-4 py-6 text-center text-gray-500">
                    Aucun utilisateur trouvé.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}

export default User;